import * as Actions from './SessionQuestionsActions';
import { SortOrder } from '../../Utils/Constants';

const initialState = {
  fetching: false,
  sessionQAndAs: [],
  currentPage: 0,
  page: {
    size: 0,
    totalElements: 0,
    totalPages: 0,
    number: 0
  },
  filter: {
    textSearch: null,
    answered: null,
    dateAskedSortOrder: SortOrder.DESC
  },
  error: null
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case Actions.GET_SESSION_QUESTIONS_REQUEST: {
      const { filter, pageNumber } = action.payload;
      return {
        ...state,
        fetching: true,
        currentPage: pageNumber,
        filter: {
          ...state.filter,
          ...filter
        }
      };
    }
    case Actions.GET_SESSION_QUESTIONS_SUCCESS: {
      const { sessionQAndAs, page } = action.payload;
      return {
        ...state,
        sessionQAndAs: sessionQAndAs,
        page: {
          size: page.size,
          totalElements: page.totalElements,
          totalPages: page.totalPages,
          number: page.number
        },
        fetching: false
      };
    }
    case Actions.GET_SESSION_QUESTIONS_FAILURE: {
      return { ...state, ...initialState, error: action.error, fetching: false };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/Reducks/SessionQuestions/SessionQuestionsReducer.js